

//%                 Auth Types                              //
export const SIGN_IN = 'SIGN_IN';
export const SIGN_OUT = 'SIGN_OUT';
export const SIGN_UP = 'SIGN_UP';
export const IS_WEB_TOKEN_VALID = 'IS_WEB_TOKEN_VALID';

export const IS_FETCHING_USER = "IS_FETCHING_USER";
export const USER_FETCHED = "USER_FETCHED";




//$             Word Api Types                               //
export const GET_WORD_PACKET = 'GET_WORD_PACKET';
export const GET_WORD_BANK = 'GET_WORD_BANK';
export const   GET_LEADER_BOARD =  'GET_LEADER_BOARD'; 

export const WOD_ADD_KNOWN_WORD_SUCCEEDED = 'WOD_ADD_KNOWN_WORD_SUCCEEDED';
export const WOD_ADD_KNOWN_WORD_FAILED = 'WOD_ADD_KNOWN_WORD_FAILED';

export const SKIP_WORD_FROM_WORD_PACKET = 'SKIP_WORD_FROM_WORD_PACKET';

export const WORD_ARRAY_ADD_KNOWN_WORD_SUCCEEDED = 'WORD_ARRAY_ADD_KNOWN_WORD_SUCCEEDED';
export const WORD_ARRAY_ADD_KNOWN_WORD_FAILED = 'WORD_ARRAY_ADD_KNOWN_WORD_FAILED';

export const ADD_OWN_WORD = 'ADD_OWN_WORD';
export const ADD_WORD_TO_LEARN = 'ADD_WORD_TO_LEARN';
export const CHECK_RETURNS_TO_TEST = 'CHECK_RETURNS_TO_TEST';
export const RETURN_TEST_REPORTED_SUCCESSFULLY = 'RETURN_TEST_REPORTED_SUCCESSFULLY' 

export const FLAG_WORD_ASSET = 'FLAG_WORD_ASSET';

export const FETCH_SYSTEM_METRICS = 'FETCH_SYSTEM_METRICS'; 

export const REMOVE_IGNORED_WORD =  'REMOVE_IGNORED_WORD';
export const REMOVE_FROM_CURRENT_3 = 'REMOVE_FROM_CURRENT_3';